export default {
  users: (state) => state.userResult?.users || [],
};
